import React, { useState, useRef, useEffect } from "react";
import { ChevronDown, Check, Search } from "lucide-react";
import DateRangePicker from "./DateRangePicker";

const FilterDropdown = ({
  icon: Icon,
  value,
  onChange,
  options,
  placeholder,
  showSearch = false,
  searchPlaceholder = "Search...",
  showDatePicker = false,
  onDateSelect,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [showCustomDatePicker, setShowCustomDatePicker] = useState(false);
  const dropdownRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
        setSearchTerm("");
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const selectedOption = options.find((option) => option.value === value);
  const displayText = selectedOption ? selectedOption.label : placeholder;

  // Filter options based on search term
  const filteredOptions = showSearch
    ? options.filter((option) =>
        option.label.toLowerCase().includes(searchTerm.toLowerCase())
      )
    : options;

  return (
    <div
      className={`sales-filter-dropdown ${isOpen ? "show" : ""}`}
      ref={dropdownRef}
    >
      <button
        className="sales-filter-dropdown-btn"
        onClick={() => setIsOpen(!isOpen)}
      >
        {Icon && <Icon size={16} className="sales-filter-icon" />}
        <span className="sales-filter-text">{displayText}</span>
        <ChevronDown size={16} className="sales-filter-dropdown-arrow" />
      </button>

      {isOpen && (
        <div className="sales-filter-dropdown-menu no-scrollbar show">
          {showSearch && (
            <div className="sales-filter-search-container">
              <Search size={16} className="sales-filter-search-icon" />
              <input
                type="text"
                className="sales-filter-search-input"
                placeholder={searchPlaceholder}
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                onClick={(e) => e.stopPropagation()}
              />
            </div>
          )}
          {filteredOptions.map((option) => (
            <button
              key={option.value}
              className={`sales-filter-option ${
                value === option.value ? "selected" : ""
              }`}
              onClick={() => {
                if (option.value === "custom" && showDatePicker) {
                  setShowCustomDatePicker(true);
                  setIsOpen(false);
                } else {
                  onChange(option.value);
                  setIsOpen(false);
                  setSearchTerm("");
                }
              }}
            >
              {value === option.value && (
                <Check size={16} className="sales-filter-dropdown-check" />
              )}
              {option.label}
            </button>
          ))}
        </div>
      )}

      {showCustomDatePicker && (
        <DateRangePicker
          onApply={(date) => {
            setShowCustomDatePicker(false);
            if (onDateSelect) {
              onDateSelect(date);
            }
          }}
          onCancel={() => setShowCustomDatePicker(false)}
        />
      )}
    </div>
  );
};

export default FilterDropdown;
